import { Dayjs } from "dayjs"
import { IStatus } from "@/types/Status"

export interface ISmartMeter {
  deviceStatus?: string
  errorCode?: string
  errorStatus?: string
  installationDate?: Dayjs
  lastOrchestration?: string
  meterType?: string
  mpxn?: string
  msn?: string
  orchestrationStatus?: string
  pk?: number
  serviceRequest?: string
  latestAlert?: string
  latestAlertStatus?: string
  latestAlertDate?: Dayjs
  reading?: number
  readingDateTime?: Dayjs
  workstream?: string
  firmwareStatus?: string
  firmwareVersion?: string
  manufacturer?: string
  model?: string
  variant?: string
  paymentMode?: string
  smetsVersion?: string
  gbcsVersion?: string
  region?: string
  deviceId?: string
  ssd?: Dayjs
  commsHubId?: string

  readonly isGas: boolean
  readonly isElectricity: boolean
  readonly latestReading: number | null
  readonly workstreamStatuses: IStatus[] | []
  readonly installer: string
  readonly latestReadingFormatted: string | null
  readonly modelName: string[]
  readonly manufacturerName: string[]
  readonly modelNameFormatted: string
  readonly manufacturerNameFormatted: string
}

export enum DownloadSmartMetersBy {
  ID = "Id",
  FILTER = "Filter",
}

export enum meterTypes {
  GAS = "GSME",
  ELEC = "ESME",
}
